import { render } from "./MaterialsDictaphones.vue?vue&type=template&id=2760b51a"
import script from "./MaterialsDictaphones.vue?vue&type=script&lang=js"
export * from "./MaterialsDictaphones.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__